import { isOutSideBottom, isOutSideTop, isOutsideLeft, isOutsideRight } from "./checkTooltipOutside";
import { INITIAL_X_TRANSFORM, INITIAL_Y_TRANSFORM, ROUNDING_COMPENSATION_TRANSFORM, SIDE_GAP } from "./constants";
/**
 * Если знак вопроса стоит близко к границе, то из-за закругления указатель выходит за границу тултипа,
 * поэтому двигаем тултип ближе к указателю
 * @param translate - смещение тултипа относительно границы контейнера
 * @param compensationDirection - направление смещения относительно указателя
 * @param isXTransform - смещение по оси X или Y к указателю
 */
var getTranslateWithRoundingCompensation = function getTranslateWithRoundingCompensation(_ref) {
  var translate = _ref.translate,
    compensationDirection = _ref.compensationDirection,
    isXTransform = _ref.isXTransform;
  return isXTransform ? "translate(".concat(translate, ", ").concat(compensationDirection).concat(ROUNDING_COMPENSATION_TRANSFORM, "px)") : "translate(".concat(compensationDirection).concat(ROUNDING_COMPENSATION_TRANSFORM, "px, ").concat(translate, ")");
};

/**
 * Смещение тултипа для того, чтобы входил в контейнер
 * @param shiftPosition - смещение тултипа относительно границы контейнера
 * @param compensationDirection - направление смещения относительно указателя
 * @param isSideGap - не добавляем SIDE_GAP, если знак вопроса стоит близко к границе,
 * иначе указатель тоже выходит за пределы тултипа
 * @param isXTransform - смещение по оси X или Y к указателю
 */
var getTranslate = function getTranslate(_ref2) {
  var shiftPosition = _ref2.shiftPosition,
    compensationDirection = _ref2.compensationDirection,
    isSideGap = _ref2.isSideGap,
    isXTransform = _ref2.isXTransform;
  var transformBias = isXTransform ? INITIAL_X_TRANSFORM : INITIAL_Y_TRANSFORM;
  var translate = "calc(-50% + ".concat(transformBias, "px + ").concat(shiftPosition, "px)");
  var res = isXTransform ? "translateX(".concat(translate, ")") : "translateY(".concat(translate, ")");
  if (!isSideGap) {
    res = getTranslateWithRoundingCompensation({
      translate: translate,
      compensationDirection: compensationDirection,
      isXTransform: isXTransform
    });
  }
  return res;
};

/* вычисляет необходимо ли смещать позицию тултипа в зависимости от положения во вьюпорте
 * */
var calculateTooltipPosition = function calculateTooltipPosition(_ref3) {
  var tooltipMessageRect = _ref3.tooltipMessageRect,
    tooltipWrapRect = _ref3.tooltipWrapRect,
    position = _ref3.position,
    shiftX = _ref3.shiftX,
    shiftY = _ref3.shiftY,
    containerWidth = _ref3.containerWidth,
    containerHeight = _ref3.containerHeight,
    containerRect = _ref3.containerRect;
  var res = {
    right: undefined,
    left: undefined,
    shiftX: shiftX,
    shiftY: shiftY,
    nextPosition: position
  };
  if (position === 'top' || position === 'bottom') {
    // проверяем выход за пределы экрана сверху
    var checkOutsideTop = isOutSideTop(tooltipMessageRect.top, containerRect === null || containerRect === void 0 ? void 0 : containerRect.top);
    var checkOutsideBottom = isOutSideBottom({
      tooltipMessageRect: tooltipMessageRect,
      containerHeight: containerHeight,
      bottomContainerPosition: containerRect === null || containerRect === void 0 ? void 0 : containerRect.bottom
    });
    if (checkOutsideTop) {
      res.nextPosition = 'bottom';
    }

    // проверяем выход за пределы экрана снизу
    if (checkOutsideBottom) {
      res.nextPosition = 'top';
    }
    var compensationDirection = res.nextPosition === 'bottom' ? '-' : '';
    if (isOutsideLeft(tooltipMessageRect.left, containerRect === null || containerRect === void 0 ? void 0 : containerRect.left)) {
      var shiftPosition = parseInt("".concat(-(tooltipWrapRect.left - SIDE_GAP)), 10);
      // Если есть контейнер, делаем смещение относительно базового смещения вида:
      // transform: translateX(calc(-50% + ${INITIAL_X_TRANSFORM}px));
      // по другим сторонам аналогично
      if (containerRect !== null && containerRect !== void 0 && containerRect.left) {
        var isSideGap = tooltipWrapRect.left - containerRect.left > SIDE_GAP;
        shiftPosition = parseInt("".concat(containerRect.left - tooltipMessageRect.left + (isSideGap ? SIDE_GAP : 0)), 10);
        res.shiftX = getTranslate({
          shiftPosition: shiftPosition,
          compensationDirection: compensationDirection,
          isSideGap: isSideGap,
          isXTransform: true
        });
        return res;
      }
      res.shiftX = "translateX(".concat(shiftPosition < 0 ? shiftPosition : 0, "px)");
    } else if (isOutsideRight({
      tooltipMessageRect: tooltipMessageRect,
      containerWidth: containerWidth,
      rightContainerPosition: containerRect === null || containerRect === void 0 ? void 0 : containerRect.right
    })) {
      if (containerRect !== null && containerRect !== void 0 && containerRect.right) {
        var _isSideGap = containerRect.right - tooltipWrapRect.right > SIDE_GAP;
        var _shiftPosition = parseInt("-".concat(tooltipMessageRect.right - containerRect.right + (_isSideGap ? SIDE_GAP : 0)), 10);
        res.shiftX = getTranslate({
          shiftPosition: _shiftPosition,
          compensationDirection: compensationDirection,
          isSideGap: _isSideGap,
          isXTransform: true
        });
        return res;
      }
      if (tooltipWrapRect.right < containerWidth - SIDE_GAP) {
        var _shiftPosition2 = parseInt("".concat(-(tooltipMessageRect.width - (containerWidth - tooltipWrapRect.right + Number(tooltipWrapRect.width)) + SIDE_GAP)), 10);
        res.shiftX = "translateX(".concat(_shiftPosition2, "px)");
      } else {
        res.shiftX = 'none';
        res.right = "".concat(-SIDE_GAP, "px");
      }
    } else if (!checkOutsideTop && !checkOutsideBottom) {
      res.shiftX = "translateX(calc(-50% + ".concat(tooltipWrapRect.width / 2, "px))");
    }
  }
  if (position === 'right' || position === 'left') {
    // проверяем выход за пределы экрана слева или справа
    if (isOutsideLeft(tooltipMessageRect.left, containerRect === null || containerRect === void 0 ? void 0 : containerRect.left)) {
      res.right = 'auto';
      res.left = '100%';
      res.nextPosition = 'right';
    } else if (isOutsideRight({
      tooltipMessageRect: tooltipMessageRect,
      containerWidth: containerWidth,
      rightContainerPosition: containerRect === null || containerRect === void 0 ? void 0 : containerRect.right
    })) {
      res.left = 'auto';
      res.right = '100%';
      res.nextPosition = 'left';
    }
    var _compensationDirection = res.nextPosition === 'right' ? '-' : '';
    if (isOutSideTop(tooltipMessageRect.top, containerRect === null || containerRect === void 0 ? void 0 : containerRect.top)) {
      var _shiftPosition3 = parseInt("".concat(-(tooltipWrapRect.top - SIDE_GAP)), 10);
      if (containerRect !== null && containerRect !== void 0 && containerRect.top) {
        var _isSideGap2 = tooltipWrapRect.top - containerRect.top > SIDE_GAP;
        _shiftPosition3 = parseInt("".concat(containerRect.top - tooltipMessageRect.top + (_isSideGap2 ? SIDE_GAP : 0)), 10);
        res.shiftY = getTranslate({
          shiftPosition: _shiftPosition3,
          compensationDirection: _compensationDirection,
          isSideGap: _isSideGap2,
          isXTransform: false
        });
        return res;
      }
      res.shiftY = "translateY(".concat(_shiftPosition3 < 0 ? _shiftPosition3 : 0, "px)");
    }
    if (isOutSideBottom({
      tooltipMessageRect: tooltipMessageRect,
      containerHeight: containerHeight,
      bottomContainerPosition: containerRect === null || containerRect === void 0 ? void 0 : containerRect.bottom
    })) {
      var _shiftPosition4 = parseInt("".concat(-(tooltipMessageRect.height - (containerHeight - tooltipWrapRect.bottom + Number(tooltipWrapRect.height)) + SIDE_GAP)), 10);
      if (containerRect !== null && containerRect !== void 0 && containerRect.bottom) {
        var _isSideGap3 = containerRect.bottom - tooltipWrapRect.bottom > SIDE_GAP;
        _shiftPosition4 = parseInt("-".concat(tooltipMessageRect.bottom - containerRect.bottom + (_isSideGap3 ? SIDE_GAP : 0)), 10);
        res.shiftY = getTranslate({
          shiftPosition: _shiftPosition4,
          compensationDirection: _compensationDirection,
          isSideGap: _isSideGap3,
          isXTransform: false
        });
        return res;
      }
      if (tooltipMessageRect.height - tooltipWrapRect.height - _shiftPosition4 > 0) {
        res.shiftY = "translateY(".concat(_shiftPosition4, "px)");
      }
    }
  }
  return res;
};
export { calculateTooltipPosition };